import type { ReactElement } from 'react';
import { Box, Text } from '@mantine/core';
import { ListChecks } from 'lucide-react';
import PageLevelFilterRow from '@/shared/surfaces/PageLevelFilterRow';
import PageHeaderComponent from '@/design/PageHeaderComponent';
import SurfaceAssistScope, { SurfaceAssistToolbar } from '@/shared/surfaces/assist/SurfaceAssistScope';
import { useSurface } from '@/shared/surfaces/useSurface';
import TopicNotFound from '@/shared/surfaces/TopicNotFound';
import GovernanceIssuesTab from './GovernanceIssuesTab';

/** Governance › Issues: the unified issue tracker — policy verdicts and sensitive-data alerts, filterable by source. */
export default function GovernanceIssuesPage(): ReactElement {
    const surface = useSurface('governance');
    if (surface === undefined) return <TopicNotFound />;

    return (
        <SurfaceAssistScope surface={surface}>
            <Box pb="xl">
                <PageLevelFilterRow inactive inactiveNote="Not applied — issues list all open findings" assist={<SurfaceAssistToolbar surface={surface} />} />

                <PageHeaderComponent
                    icon={ListChecks}
                    eyebrow="Governance"
                    title="Issues"
                    subtitle="Track governance findings to resolution — policy verdicts and sensitive-data alerts."
                />

                <Text size="sm" c="dimmed" mb="md">
                    Open a row to add notes, assign, resolve, and review the audit trail.
                </Text>
                <GovernanceIssuesTab />
            </Box>
        </SurfaceAssistScope>
    );
}
